import axios from 'axios'

const standard = axios.create({
    baseURL: '',
    timeout: 100000,
    transformResponse: [
        function (data) {
            return data
        }
    ],
    withCredentials: true
})

standard.interceptors.request.use(function (config) {

    config.headers.Locale = localStorage.getItem('locale') || 'pt'

    config.headers.token = localStorage.getItem('token')

    return config;
  }, function (error) {

    return Promise.reject(error);
  });

export default standard
